import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, SERVICES, CONTACT } from "../../data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Subscribe = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/subscribe`, { email });
      toast.success("Subscribed. Insights will land in your inbox.");
      setEmail("");
    } catch {
      toast.error("Please enter a valid email.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="flex border-b border-white/25 focus-within:border-white" data-testid="footer-subscribe-form">
      <input
        type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
        placeholder="Your work email" data-testid="footer-subscribe-input"
        className="w-full bg-transparent py-3 text-sm text-white placeholder:text-zinc-400 outline-none"
      />
      <button disabled={busy} data-testid="footer-subscribe-button" className="px-2 text-white transition-transform hover:translate-x-1" aria-label="Subscribe">
        <ArrowRight className="h-5 w-5" />
      </button>
    </form>
  );
};

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-[var(--ink)] text-zinc-300">
    <div className="mx-auto max-w-[1400px] px-5 pt-20 sm:px-8">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Logo light />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-zinc-400">
            A fast-growing market research agency. Young, dynamic professionals backed by domain experts, delivering high-value research at competitive prices.
          </p>
          <div className="mt-8 max-w-sm">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">Insights, monthly</p>
            <Subscribe />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-7">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">Navigate</p>
            <ul className="mt-5 space-y-3 text-sm">
              {NAV.map((n) => <li key={n.to}><Link to={n.to} data-testid={`footer-link-${n.label.toLowerCase()}`} className="hover:text-white">{n.label}</Link></li>)}
            </ul>
          </div>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">Services</p>
            <ul className="mt-5 space-y-3 text-sm">
              {SERVICES.map((s) => <li key={s.slug}><Link to={`/services#${s.slug}`} className="hover:text-white">{s.title}</Link></li>)}
            </ul>
          </div>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">Contact</p>
            <ul className="mt-5 space-y-3 text-sm" data-testid="footer-contact">
              <li>{CONTACT.email}</li><li>{CONTACT.phone}</li><li>{CONTACT.address}</li>
            </ul>
          </div>
        </div>
      </div>
      <p aria-hidden="true" className="mt-20 select-none text-[22vw] font-bold leading-[0.8] tracking-[-0.06em] text-white/[0.06]">wireaxis</p>
      <div className="flex flex-col justify-between gap-3 border-t border-white/10 py-6 text-xs text-zinc-400 sm:flex-row">
        <p>© {new Date().getFullYear()} Wireaxis. All rights reserved.</p>
        <p className="font-mono uppercase tracking-[0.2em]">Research · Operations · Consultancy</p>
      </div>
    </div>
  </footer>
);
